import { render } from "./functional_information_effectView.vue?vue&type=template&id=3fef5bab"
import script from "./functional_information_effectView.vue?vue&type=script&lang=js"
export * from "./functional_information_effectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__